import { Drawer } from "@mui/material";

/**
 * Componente contenedor responsivo para el sidebar
 */
const ResponsiveSidebarContainer = ({
  isSmallScreen,
  open,
  onClose,
  paperWidth = 420,
  anchor = "left",
  children,
}) => {
  if (isSmallScreen) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        variant="temporary"
        anchor={anchor}
        ModalProps={{
          keepMounted: true,
          disablePortal: true,
        }}
        PaperProps={{
          sx: {
            width: paperWidth,
            maxWidth: "90vw",
            height: "100%",
            zIndex: (theme) => theme.zIndex.modal + 1,
          },
        }}
      >
        {children}
      </Drawer>
    );
  }

  return children;
};

export default ResponsiveSidebarContainer;
